// TOUR-17 — Admin member invite + approvals (obligation-light §5.3).

import type { FireflyTourArtifact } from "../tourTypes";

export const ADMIN_MEMBERS_TOUR_ID = "tour-admin-members";

export const ADMIN_MEMBERS_TOUR: FireflyTourArtifact = {
  id: ADMIN_MEMBERS_TOUR_ID,
  version: 1,
  defaultIntent: "teaching",
  intents: [
    "admin members tour",
    "add team member tour",
    "how do i invite a user",
    "invite a team member",
    "approve pending user",
    "member roles tour",
    "how do i add someone to my org",
  ],
  bucketRelevance: ["admin"],
  requiredRoles: ["admin", "owner", "org_admin", "org_owner"],
  steps: [
    {
      id: "nav-admin",
      target: { mode: "admin", anchorId: "mode-nav-admin", scrollIntoView: true },
      deferModeNavigation: true,
      skipWhenCurrentMode: "admin",
      copy: {
        title: "Open Admin",
        body: "Member invites and role assignment live here under Admin. Tap Admin in the sidebar (or bottom bar on mobile) when you are ready to review access.",
      },
      waitForClick: true,
    },
    {
      id: "users-card",
      target: { mode: "admin", anchorId: "admin-users-card", scrollIntoView: true },
      copy: {
        title: "App User Admin",
        body: "Open App User Admin for pending sign-ups, role changes, active members, and email invites — all optional, on your schedule.",
      },
      waitForClick: true,
    },
    {
      id: "pending-approvals",
      target: { mode: "admin", anchorId: "admin-pending-approvals", scrollIntoView: true },
      copy: {
        title: "Pending approvals",
        body: "Self-signups land here until you assign a role. Empty is fine — no backlog obligation. Approve and assign when you are ready.",
      },
      advanceOn: "next_button",
    },
    {
      id: "invite-section",
      target: { mode: "admin", anchorId: "admin-invite-section", scrollIntoView: true },
      copy: {
        title: "Invite User",
        body: "Expand Invite User to email someone directly — they skip the approval queue when the invite sends successfully.",
      },
      waitForClick: true,
    },
    {
      id: "invite-email",
      target: { mode: "admin", anchorId: "admin-invite-email", scrollIntoView: true },
      copy: {
        title: "Invite email",
        body: "Enter the teammate's email. They complete signup from the invite link, then sign in with Google or the same email.",
      },
      advanceOn: "next_button",
    },
    {
      id: "invite-role",
      target: { mode: "admin", anchorId: "admin-invite-role", scrollIntoView: true },
      copy: {
        title: "Org role",
        body: "Pick the role before sending — sales, trainer, admin, and other org tokens control which modes they see.",
      },
      advanceOn: "next_button",
    },
    {
      id: "invite-send",
      target: { mode: "admin", anchorId: "admin-invite-send", scrollIntoView: true },
      copy: {
        title: "Send invite",
        body: "Send Invite emails the link and assigns the role immediately. You perform this step yourself — the tour will not send on your behalf.",
      },
      destructive: true,
    },
    {
      id: "ask-firefly",
      target: { mode: "admin", anchorId: "ask-firefly", scrollIntoView: true },
      copy: {
        title: "Ask Firefly anytime",
        body: "Org settings and locations live under Org Administration on this same Admin surface. Ask Firefly anytime for other mode tours.",
      },
      advanceOn: "next_button",
    },
  ],
};
